module.exports = __webpack_public_path__ + "static/media/Fomantis_gaussian2.0b7b0093.png";